export const ActiveStatus = {
  Active: 0,
  Deleted: 1,
  All: 3,
};
